import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MovingStaircaseIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				d="M6 3C6.55228 3 7 2.55228 7 2C7 1.44772 6.55228 1 6 1C5.44772 1 5 1.44772 5 2C5 2.55228 5.44772 3 6 3Z"
			></path>
			<path
				fill="currentColor"
				d="M12.3448 6.65217C12.2689 6.65217 12.1973 6.69083 12.1517 6.75652L7.51724 13.4348C6.83346 14.4201 5.76033 15 4.62069 15H2.68966C1.75648 15 1 14.1824 1 13.1739C1 12.1654 1.75648 11.3478 2.68966 11.3478H4.62069C4.69667 11.3478 4.76821 11.3092 4.81379 11.2435L9.44828 4.56522C10.1321 3.57989 11.2052 3 12.3448 3H13.3103C14.2435 3 15 3.81757 15 4.82609C15 5.83461 14.2435 6.65217 13.3103 6.65217H12.3448Z"
			></path>
			<path
				fill="currentColor"
				d="M8 4.5L4.5 9V5C4.5 4.44772 4.94772 4 5.5 4H6.2918C6.75753 4 7.21687 4.10844 7.63344 4.31672L8 4.5Z"
			></path>
		</svg>
	),
)
